import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 路由配置，添加meta字段定义权限
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin', 'salesman'] }
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('../views/Product.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/product-management',
    name: 'ProductManagement',
    component: () => import('../views/ProductManagement.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/gift',
    name: 'Gift',
    component: () => import('../views/Gift.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/category',
    name: 'Category',
    component: () => import('../views/Category.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/customer',
    name: 'Customer',
    component: () => import('../views/Customer.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/manufacturer',
    name: 'Manufacturer',
    component: () => import('../views/Manufacturer.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/inbound',
    name: 'InboundManagement',
    component: () => import('../views/InboundManagement.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/outbound',
    name: 'OutboundManagement',
    component: () => import('../views/OutboundManagement.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/approval',
    name: 'ApprovalManagement',
    component: () => import('../views/ApprovalManagement.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/customer/:id',
    name: 'CustomerDetail',
    component: () => import('../views/CustomerDetail.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/sales-order',
    name: 'SalesOrder',
    component: () => import('../views/SalesOrder.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/vip-order',
    name: 'VipOrder',
    component: () => import('../views/VipOrder.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/normal-order',
    name: 'NormalOrder',
    component: () => import('../views/NormalOrder.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/stock',
    name: 'StockManagement',
    component: () => import('../views/StockManagement.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/inventory',
    redirect: '/stock'
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('../views/User.vue'),
    meta: { requiresAuth: true, roles: ['super_admin'] }
  },
  {
    path: '/operation-log',
    name: 'OperationLog',
    component: () => import('../views/OperationLog.vue'),
    meta: { requiresAuth: true, roles: ['super_admin'] }
  },
  {
    path: '/data-backup',
    name: 'DataBackup',
    component: () => import('../views/DataBackup.vue'),
    meta: { requiresAuth: true, roles: ['super_admin'] }
  },
  {
    path: '/menu-management',
    name: 'MenuManagement',
    component: () => import('../views/MenuManagement.vue'),
    meta: { requiresAuth: true, roles: ['super_admin'] }
  },
  {
    path: '/customer-label',
    name: 'CustomerLabel',
    component: () => import('../views/CustomerLabel.vue'),
    meta: { requiresAuth: true, roles: ['super_admin'] }
  },
  {
    path: '/customer-category',
    name: 'CustomerCategory',
    component: () => import('../views/CustomerCategory.vue'),
    meta: { requiresAuth: true, roles: ['super_admin'] }
  },
  {
    path: '/applicable-type',
    name: 'ApplicableType',
    component: () => import('../views/ApplicableType.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/forbidden-list',
    name: 'ForbiddenList',
    component: () => import('../views/ForbiddenList.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/outbound-type',
    name: 'OutboundType',
    component: () => import('../views/OutboundType.vue'),
    meta: { requiresAuth: true, roles: ['super_admin'] }
  },
  {
    path: '/gift-recipient',
    name: 'GiftRecipient',
    component: () => import('../views/GiftRecipient.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin', 'salesman'] }
  },
  {
    path: '/system-config',
    name: 'SystemConfig',
    component: () => import('../views/SystemConfig.vue'),
    meta: { requiresAuth: true, roles: ['super_admin'] }
  },
  {
    path: '/customer-alert',
    name: 'CustomerAlert',
    component: () => import('../views/CustomerAlert.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin'] }
  },
  {
    path: '/user-task',
    name: 'UserTask',
    component: () => import('../views/UserTask.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin', 'salesman'] }
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('../views/Report.vue'),
    meta: { requiresAuth: true, roles: ['super_admin', 'admin', 'salesman'] }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 检查是否需要认证
  if (to.meta.requiresAuth !== false) {
    const token = sessionStorage.getItem('token')
    const userStr = sessionStorage.getItem('user')
    
    if (!token || !userStr) {
      // 未登录，跳转到登录页
      next('/login')
      return
    }
    
    try {
      const user = JSON.parse(userStr)
      const userRole = user.role
      
      // 检查用户是否有权限访问该路由
      if (to.meta.roles && !to.meta.roles.includes(userRole)) {
        // 业务员可进入所有"行政管理员"可进的页面（具体能做什么由功能权限控制按钮/接口）；
        // 超管专属页(user/menu/role/backup/log 等 roles=['super_admin']) 仍拦截。
        if (userRole === 'salesman' && to.meta.roles.includes('admin')) {
          next()
          return
        }
        // 无权限，跳转到首页
        next('/dashboard')
        return
      }
    } catch (e) {
      // 解析用户信息失败，跳转到登录页
      next('/login')
      return
    }
  }
  next()
})

export default router